export default __webpack_public_path__ + "static/posterTintin-e7a5b4a8cd322499bd19259383fc0b96.svg";